<template>
  <div id="perspective" ref="materialBlock">
    <div ref="closeBtn" class="close-btn">✖</div>
    <div id="wrap">
      <!--img src="./img/1.png" />
      <img src="./img/2.png" />
      <img src="./img/3.png" />
      <img src="./img/4.png" /-->
      <template v-for="(item, n) in materialShedList" v-bind:key="n">
        <div class="material">
          <span>{{ item.shed_name }}</span>
          <img src="./img/material.png" />
        </div>
      </template>
      <p></p>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { createApp, createElement } from "vue";
import checkLoading from "@/modules/checkLoading";

import { unref } from "vue";

export default {
  //import引入的组件需要注入到对象中才能使用
  name: "MaterialSource",
  //inject: ["getSourceData", "updateSourceData"],
  inject: [
    "getSourceData",
    "updateSourceData",
    "getFactoryArea",
    "updateFactoryArea",
    "getBranchFactoryList",
    "updateLeftRightPart",
    "updateInventoryId",
    "updateInventorySwitch",
    "getMaterialShedList",
    "updateMaterialSourceShow",
    "updateSourceShow",
  ],
  components: { checkLoading },
  data() {
    //这里存放数据
    return {
      table: [],
      pageNum: 100,
      pageIndex: 0,
      rotateStatus: true,
      changePageTimer: "",
      materialShedList: [],
      loading: false,
    };
  },
  setup() {},
  mounted() {},
  //计算属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    getMaterialShedList: {
      handler(newVal, oldVal) {
        this.materialShedList = unref(newVal);

        let that = this;
        this.$nextTick(function () {
          that.initMaterialSource();
        });
      },
      deep: true,
    },
    //that.translateLeft();
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    //this.getSourceData();
    this.initMaterialSource();
  },
  //方法集合
  methods: {
    initMaterialSource() {
      let that = this;

      let materialBlock = $(this.$refs.materialBlock);
      let innerHeight = bmeConfig.INIT_HEIGHT - 100;
      let innerWidth = bmeConfig.INIT_WIDTH;

      materialBlock
        .css("height", innerHeight)
        .css("top", 100)
        .css("left", innerWidth / 4)
        .css("width", innerWidth / 2)
        .css("zIndex", 10001);

      $(this.$refs.closeBtn).css("left", innerWidth / 2 - 100 + "px");
      $(this.$refs.closeBtn).unbind("click");
      $(this.$refs.closeBtn).bind("click", function () {
        that.updateInventorySwitch(false);
        that.updateInventoryId(false);
        that.updateLeftRightPart(false);
        that.updateSourceShow(false);
      });

      var oWrap = materialBlock.find("#wrap");
      var oImg = materialBlock.find(".material");
      var oImgLength = oImg.length;
      var Deg = 360 / oImgLength;
      var nowX,
        nowY,
        lastX,
        lastY,
        minusX = 0,
        minusY = 0;
      var roY = 0,
        roX = -10;
      var timer;

      for (var i = 0; i < oImgLength; i++) {
        oImg.get(i).style.transform = "rotateY(" + i * Deg + "deg) translateZ(350px)";
        oImg.get(i).style.transition = "transform 1s " + (oImgLength - 1 - i) * 0.1 + "s";
      }

      oWrap.css("marginTop", innerHeight / 2 - 180 + "px");

      materialBlock.unbind("mousedown");
      materialBlock.bind("mousedown", function (ev) {
        ev = ev || window.event;

        //鼠标按下的时候，给前一点坐标赋值，为了避免第一次相减的时候出错
        lastX = ev.clientX;
        lastY = ev.clientY;

        //移动
        materialBlock.unbind("mousemove");
        materialBlock.bind("mousemove", function (ev) {
          ev = ev || window.event;

          clearInterval(timer);

          nowX = ev.clientX; // clientX 鼠标距离页面左边的距离
          nowY = ev.clientY; // clientY ………………………………顶部………………

          //当前坐标和前一点坐标差值
          minusX = nowX - lastX;
          minusY = nowY - lastY;

          //更新wrap的旋转角度，拖拽越快-> minus变化大 -> roY变化大 -> 旋转快
          roY += minusX * 0.2; // roY = roY + minusX*0.2;
          roX -= minusY * 0.1;

          //oWrap.style.transform = "rotateX(" + roX + "deg) rotateY(" + roY + "deg)";
          oWrap.css("transform", "rotateX(" + roX + "deg) rotateY(" + roY + "deg)");
          /*
						//生成div，让div跟着鼠标动
						var oDiv = document.createElement('div');
						oDiv.style.cssText = 'width:5px;height:5px;background:red;position:fixed;left:'+nowX+'px;top:'+nowY+'px';
						this.body.appendChild(oDiv);
						*/

          //前一点的坐标
          lastX = nowX;
          lastY = nowY;
        });

        materialBlock.unbind("mouseup");
        materialBlock.bind("mouseup", function (ev) {
          materialBlock.unbind("mousemove");
          timer = setInterval(function () {
            minusX *= 0.95;
            minusY *= 0.95;
            roY += minusX * 0.2; // roY = roY + minusX*0.2;
            roX -= minusY * 0.1;
            //oWrap.style.transform = "rotateX(" + roX + "deg) rotateY(" + roY + "deg)";
            oWrap.css("transform", "rotateX(" + roX + "deg) rotateY(" + roY + "deg)");

            if (Math.abs(minusX) < 0.1 && Math.abs(minusY) < 0.1) {
              clearInterval(timer);
            }
          }, 13);
        });
        return false;
      });
    },
  },
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="scss">
.close-btn {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100px;
  height: 100px;
  font-size: 55px;
  text-align: center;
  line-height: 100px;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}

#perspective {
  perspective: 1200px;
  display: block;
  position: absolute;
  pointer-events: all;
}
#wrap {
  width: 120px; /*133:200  4:6  */
  height: 180px;
  margin: 0 auto;
  position: relative;

  /*搭建3D效果必须的两个属性：一个变换风格变3d，一个场景景深800px*/
  transform-style: preserve-3d;
  transform: rotateX(-10deg) rotateY(0deg);
}
#wrap > .material {
  width: 90px;
  height: 120px;
  text-align: center;
  padding: 15px 0;
  overflow: hidden;
  position: absolute;
  border-radius: 1px;
  background: rgba(255, 255, 255, 0.55);
  box-shadow: 7px 9px 6px #00000075;
  border: 1px solid #fff;
  border-radius: 10px;

  transform: rotateY(0deg) translateZ(0px);
  /*倒影：朝向 偏移 遮盖*/ /*线性渐变(从哪里开始,开始时候的颜色,结束时候的颜色)*/
  -webkit-box-reflect: below 5px -webkit-linear-gradient(top, rgba(0, 0, 0, 0) 40%, rgba(
          0,
          0,
          0,
          0.5
        )
        100%);
  img {
    width: 60px;
    height: 60px;
    margin: auto;
    padding: 10px 5px;
  }
  span {
    font-size: 12px;
    color: #000;
    font-weight: bolder;
  }
}

#wrap > .material:before {
  content: "";
  position: absolute;
  z-index: 1;
  top: 0;
  right: -17%;
  width: 50%;
  height: 100%;
  background: white;
  opacity: 0.15;
  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
  transform-origin: center center;
  -webkit-transform: skew(-30deg) scaleY(1) translate(0, 0);
  -ms-transform: skew(-30deg) scaleY(1) translate(0, 0);
  transform: skew(-30deg) scaleY(1) translate(0, 0);
  -webkit-transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
  transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
}

#wrap p {
  width: 1200px;
  height: 1200px;
  background: -webkit-radial-gradient(
    center center,
    600px 600px,
    rgba(244, 23, 234, 0.2),
    rgba(0, 0, 0, 0)
  );
  border-radius: 100%;
  position: absolute;
  left: 50%;
  top: 102%;
  margin-left: -600px;
  margin-top: -600px;
  transform: rotateX(90deg);
}
</style>
